import {observer} from 'mobx-react';
import {Tag} from 'shared/components';
import AiSparkle from 'img/ai-sparkle.svg';

const AiScreenerRatingTag = observer(({candidate}) => {
  return (
    <Tag colour={candidate.aiScreenerResult.colour} className='ml1'>
      <div className='flex align-items-middle'>
        <div style={{marginTop: 1.5}}>{candidate.aiScreenerResult.ratingDisplay}</div>
        <img style={{height: '14px', width: '14px', marginLeft: '.25rem', marginBottom: 2}} src={AiSparkle} role='presentation'/>
      </div>
    </Tag>
  );
});

export default AiScreenerRatingTag;
